import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { tokens } from "./tokens";
import StatusPill from "./StatusPill";

/**
 * Shell de página para los módulos Etapa 2: header denso (título + subtítulo +
 * acciones) sobre canvas frío. Sin hero sections ni aire vacío (§1, §4).
 *
 * @param {string} title
 * @param {string} [subtitle]
 * @param {string} [moduleTag]  - ej. "Module N" / "CDCI"
 * @param {boolean} [devPreview] - muestra pill "Development preview — sample data"
 * @param {React.ReactNode} [actions]
 * @param {React.ReactNode} children
 */
export default function ClinicalPageShell({
  title,
  subtitle,
  moduleTag,
  devPreview = false,
  actions,
  children,
}) {
  return (
    <Box
      sx={{
        minHeight: "100%",
        bgcolor: tokens.canvas,
        px: { xs: 2, md: 3 },
        py: 2,
        fontFamily: tokens.fontUI,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ mb: subtitle ? 0.25 : 1.5, flexWrap: "wrap", rowGap: 1 }}
      >
        <Typography
          component="h1"
          sx={{
            fontFamily: tokens.fontUI,
            fontSize: 20,
            fontWeight: 600,
            color: tokens.ink,
            lineHeight: 1.3,
          }}
        >
          {title}
        </Typography>
        {moduleTag && (
          <Typography
            sx={{
              fontFamily: tokens.fontMono,
              fontSize: 11.5,
              color: tokens.ink3,
              border: `1px solid ${tokens.line}`,
              borderRadius: "4px",
              px: 0.8,
              py: "1px",
              bgcolor: tokens.surface2,
            }}
          >
            {moduleTag}
          </Typography>
        )}
        {devPreview && <StatusPill tone="info" label="Development preview — sample data" dense />}
        <Box sx={{ flex: 1 }} />
        {actions}
      </Stack>
      {subtitle && (
        <Typography sx={{ fontSize: 13, color: tokens.ink2, mb: 1.5, maxWidth: 1000 }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Box>
  );
}
